import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class CustomIconService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon(
      'file-memo',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/memo.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'printer',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/printer.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'frame',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/frame.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'files',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/files.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'book',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/book.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'columns-2',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/columns-2.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'circle-information',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/circle-information.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'file-plus-alt',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/file-plus-alt.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'palette',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/palette.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'square-dots-vertical',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/square-dots-vertical.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'trash',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/trash.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'trash-alt',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/trash-alt.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'minus',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/minus.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'plus',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/plus.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'menu',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/menu.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'arrow-down-to-bracket',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/arrow-down-to-bracket.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'arrow-right-from-bracket',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/arrow-right-from-bracket.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'arrow-right-to-bracket',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/arrow-right-to-bracket.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'arrow-sm-down',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/arrow-sm-down.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'arrow-sm-left',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/arrow-sm-left.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'arrow-sm-right',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/arrow-sm-right.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'arrow-sm-up',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/arrow-sm-up.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'bell',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/bell.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'cart-check',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/cart-check.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'cart-shopping',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/cart-shopping.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'chevron-down',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/chevron-down.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'chevron-left',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/chevron-left.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'chevron-right',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/chevron-right.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'chevron-up',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/chevron-up.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'circle-user',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/circle-user.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'receipt',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/receipt.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'wallet',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/wallet.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'money-check-dollar',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/money-check-dollar.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'house-floor',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/house-floor.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'message-circle-chat',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/message-circle-chat.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'inbox-check',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/inbox-check.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'phone-call',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/phone-call.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'mail-plus',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mail-plus.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'pinterest',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/new-icons/pinterest.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'linkedin',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/new-icons/linkedin.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'instagram',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/new-icons/instagram.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'whatsapp',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/new-icons/whatsapp.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'telegram',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/new-icons/telegram.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'headphones-alt-2',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/headphones-alt-2.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'mail-check',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mail-check.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'message-circle-heart',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/message-circle-heart.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'mobile2',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mobile2.svg')
    );
  }
}
